import { render, staticRenderFns } from "./NoVideo.vue?vue&type=template&id=01c2d694&scoped=true"
var script = {}
import style0 from "./NoVideo.vue?vue&type=style&index=0&id=01c2d694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2d694",
  null
  
)

export default component.exports